import validate from "/Users/esaia/Desktop/projects/gumbati-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45change_45middleware_45global from "/Users/esaia/Desktop/projects/gumbati-nuxt/middleware/routeChangeMiddleware.global.ts";
export const globalMiddleware = [
  validate,
  route_45change_45middleware_45global
]
export const namedMiddleware = {}